jQuery(function ($) {
	if (!$(".woocommerce-notices-wrapper").find(".close-notices").length) {
		$(".woocommerce-notices-wrapper").append(
			'<button type="button" class="close-button material-icons close-notices" aria-label="Close">&#xe5cd;</button>'
		);
	}

	// Handle Close Notices button
	$(document).on("click", ".close-notices", function () {
		$(
			".woocommerce-notices-wrapper, .woocommerce-error, .woocommerce-message"
		).fadeOut(600);
	});
});
